module.exports = __webpack_public_path__ + "img/stetho copie.e13e063c.png";